export const convertKeysToLowerCase = (oldObj) => {
  const newObj = {};
  for (let key in oldObj) {
    if (oldObj.hasOwnProperty(key)) {
      newObj[key.toLowerCase()] = oldObj[key];
    }
  }
  return newObj;
};
